export class KafkaSecurityConfig {
    'securityProtocol';
    'saslMechanism';
    'credentialsSecretArn';
    'tlsSecretArn';
    'skipTlsVerification';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "securityProtocol",
            "baseName": "securityProtocol",
            "type": "KafkaSecurityProtocol",
            "format": ""
        },
        {
            "name": "saslMechanism",
            "baseName": "saslMechanism",
            "type": "KafkaSaslMechanism",
            "format": ""
        },
        {
            "name": "credentialsSecretArn",
            "baseName": "credentialsSecretArn",
            "type": "string",
            "format": ""
        },
        {
            "name": "tlsSecretArn",
            "baseName": "tlsSecretArn",
            "type": "string",
            "format": ""
        },
        {
            "name": "skipTlsVerification",
            "baseName": "skipTlsVerification",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return KafkaSecurityConfig.attributeTypeMap;
    }
    constructor() {
    }
}
